import { createBrowserRouter, Navigate } from "react-router-dom";
import { Callback } from "../lib/auth/Callback";
import { SilentRenew } from "../lib/auth/SilentRenew";
import { ProtectedRoute } from "../lib/auth/ProtectedRoute";
import { RoleRoute } from "../lib/auth/RoleRoute";
import { App } from "../App";
import { MyTasksScreen } from "../screens/MyTasksScreen";
import { AssignedScreen } from "../screens/AssignedScreen";
import { NotificationsScreen } from "../screens/NotificationsScreen";
import { CalendarScreen } from "../screens/CalendarScreen";
import { BoardScreen } from "../screens/BoardScreen";
import { ListsScreen } from "../screens/ListsScreen";
import { TeamScreen } from "../screens/TeamScreen";
import { ContactsScreen } from "../screens/ContactsScreen";
import { ProfilScreen } from "../screens/ProfilScreen";
import { AdminScreen } from "../screens/AdminScreen";

export const router = createBrowserRouter([
  { path: "/auth/callback", element: <Callback /> },
  { path: "/auth/silent", element: <SilentRenew /> },
  {
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      { path: "/", element: <MyTasksScreen /> },
      { path: "/assignees", element: <AssignedScreen /> },
      { path: "/notifications", element: <NotificationsScreen /> },
      { path: "/calendrier", element: <CalendarScreen /> },
      { path: "/board", element: <BoardScreen /> },
      { path: "/listes", element: <ListsScreen /> },
      { path: "/contacts", element: <ContactsScreen /> },
      { path: "/profil", element: <ProfilScreen /> },
      {
        path: "/equipe",
        element: (
          <RoleRoute roles={["manager", "admin"]}>
            <TeamScreen />
          </RoleRoute>
        ),
      },
      {
        path: "/admin",
        element: (
          <RoleRoute roles={["admin"]}>
            <AdminScreen />
          </RoleRoute>
        ),
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
